

export class PoiTypeOutputWithoutStatus implements IPoiTypeOutputWithoutStatus {
    /** The auto-generated id of the poi type master */
    poi_type_id!: number;
    /** The poi type name with 255 character limit */
    poi_type_name!: string;

    constructor(data?: IPoiTypeOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_type_id = _data["poi_type_id"];
            this.poi_type_name = _data["poi_type_name"];
        }
    }

    static fromJS(data: any): PoiTypeOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTypeOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_type_id"] = this.poi_type_id;
        data["poi_type_name"] = this.poi_type_name;
        return data; 
    }
}

export interface IPoiTypeOutputWithoutStatus {
    /** The auto-generated id of the poi type master */
    poi_type_id: number;
    /** The poi type name with 255 character limit */
    poi_type_name: string;
}

